export default {
  PO: {
    programDetails: {
      uniqueId: null
    },
    uniqueId: '',
    supplier: {
    },
    supplierContacts: [],
    events: [
      {
        lineItems: [],
        uniqueId: '',
        total: '',
        fees: '',
        taxes: '',
        discounts: '',
        subtotal: ''
      }
    ],
    currency: {
      code: 'USD',
      symbol: '$',
      decimalPlaces: 2
    },
    currencySelected: false,
    total: '0',
    billTo: {},
    preparedBy: {},
    companyInfo: {},
    vat: 0,
    gst: 0
  },
  taxes: [],
  fees: []
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/purchaseOrder.js